export function useHeaderActionTracking(jobData: Ref<FlatJob | null | undefined>) {

  function isExternalApply() {
    const applicationUrl = jobData.value && jobData.value.application_url
    if (!applicationUrl)
      return false

    try {
      const url = new URL(applicationUrl)
      return !!url
    }
    catch {
      return false
    }
  }

  /**
   * Defines the header action label based on the button event and job data.
   *
   * @param event The event object.
   * @returns The header action label.
   */
  function deriveHeaderActionLabel(event: any) {
    if (event && event.source === "pitchYou" && jobData.value && jobData.value.pitch_you_url)
      return "application.whatsapp"

    if (event && event.source === "apply" && isExternalApply())
      return "application.external"

    return null
  }

  function onHeaderCtaClick(event: any) {
    const label = deriveHeaderActionLabel(event)
    if (label)
      trackHeaderActionClick(label)
  }

  function onFormIntersect(contentModules: any, module: any) {
    trackModuleViewed(contentModules, module)
    trackHeaderActionClick("application.overlay")
  }

  return {
    onHeaderCtaClick,
    onFormIntersect,
  }
}
